export default __webpack_public_path__ + "static/media/photo--sm--christina-2.12bae221.jpg";